import { UIGameMapController } from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapController.ts';
const VIEW_PADDING = 0.9;
export class UIWGameMapController extends UIGameMapController {
    onMapResized(didCanvasWidthChange) {
        if (didCanvasWidthChange) this.scaleMapView();
        this.centerMapView();
    }
    scaleMapView() {
        this.mapView.scale.set(this.getFitScale() * VIEW_PADDING);
    }
    centerMapView() {
        this.mapView.moveCenter(this.mapView.mapCenter.x, this.mapView.mapCenter.y);
    }
    constructor(uiGameManager){
        super(uiGameManager, true);
    }
}
